import React, { useState } from "react";
import "sweetalert2/dist/sweetalert2.min.css";
import "../components/Table/Table.css";
import "react-responsive-modal/styles.css";

const BillManagementSystem = () => {
  const [hostelType, setHostelType] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [photo, setPhoto] = useState("");
  const [billType, setBillType] = useState("");
  const [amount, setAmount] = useState("");

  const handleHostelTypeChange = (event) => {
    setHostelType(event.target.value);
  };

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
  };

  const handlePhotoChange = (event) => {
    setPhoto(event.target.files[0]);
  };

  const handleBillTypeChange = (event) => {
    setBillType(event.target.value);
  };

  const handleAmountChange = (event) => {
    setAmount(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    console.log("Submitting form...");
    console.log("Hostel Type:", hostelType);
    console.log("Start Date:", startDate);
    console.log("End Date:", endDate);
    console.log("Photo:", photo);
    console.log("Bill Type:", billType);
    console.log("Amount:", amount); 
    window.alert(`Submitting ${billType} bill with amount ₹${amount}`);

    switch (billType) {
      case "electricity":
        console.log("Submitting electricity bill...");
        break;
      case "gas":
        console.log("Submitting gas bill...");
        break;
      case "water":
        console.log("Submitting water bill...");
        break;
      default:
        console.log("Invalid bill type selected.");
    }

    setHostelType("");
    setStartDate("");
    setEndDate("");
    setPhoto("");
    setBillType("");
    setAmount("");
  };

  return (
    <div className="container-fluid mt-4">
      <h5 className="my-4">Bill Management System</h5>
      <form onSubmit={handleSubmit}>
        <div className="row" style={{ marginTop: "12px" }}>
          <div className="col-md-4">
            <label className="form-label">
              Hostel Type <span style={{ color: "red" }}>*</span>
            </label>
            <select
              name="hostelType"
              className="common-input form-select"
              value={hostelType}
              onChange={handleHostelTypeChange}
              required
            >
              <option value="">Select Hostel Type</option>
              <option value="girls">Girls Hostel</option>
              <option value="boys">Boys Hostel</option>
            </select>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label htmlFor="startDate">Select Date From:<span style={{ color: "red" }}>*</span> </label>
              <input
                type="date"
                id="startDate"
                className="form-control"
                value={startDate}
                onChange={handleStartDateChange}
                required
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label htmlFor="endDate">Select Date To: <span style={{ color: "red" }}>*</span></label>
              <input
                type="date"
                id="endDate"
                className="form-control"
                value={endDate}
                onChange={handleEndDateChange}
                required
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <label className="form-label mt-3">
              Photo <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="file"
              name="photo"
              accept="image/*"
              className="form-control"
              onChange={handlePhotoChange}
              required
            />
          </div>
          <div className="col-md-4">
            <label className="form-label mt-3">
              Bill Type <span style={{ color: "red" }}>*</span>
            </label>
            <select
              name="billType"
              className="common-input form-select"
              value={billType}
              onChange={handleBillTypeChange}
              required
            >
              <option value="">Select Bill Type</option>
              <option value="electricity">Electricity</option>
              <option value="gas">Gas</option>
              <option value="water">Water</option>
            </select>
          </div>
          <div className="col-md-4">
            <label className="form-label mt-3">
              Amount ₹: <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="number"
              className="form-control"
              value={amount}
              onChange={handleAmountChange}
              required
            />
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-4">
            <button type="submit" className="btn btn-primary">
              Submit
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default BillManagementSystem;
